import { type EFieldType, TField } from '@timeedit/types';
import BulkEditCategory from './BulkEditCategory';
import BulkEditCheckbox from './BulkEditCheckbox';
import BulkEditInteger from './BulkEditInteger';
import BulkEditLength from './BulkEditLength';
import BulkEditString from './BulkEditString';
import type { CommonProps } from './common';

const typeMap: Record<EFieldType, { component: any }> = {
  TEXT: { component: BulkEditString },
  SIGNATURE: { component: BulkEditString },
  EMAIL: { component: BulkEditString },
  URL: { component: BulkEditString },
  TELEPHONE: { component: BulkEditString },
  CATEGORY: { component: BulkEditCategory },
  COMMENT: { component: BulkEditString },
  INTEGER: { component: BulkEditInteger },
  LENGTH: { component: BulkEditLength },
  CHECKBOX: { component: BulkEditCheckbox },
  REFERENCE: { component: null },
  NON_SEARCHABLE_TEXT: { component: null },
  NON_SEARCHABLE_REFERENCE: { component: null },
};

const BulkEditField = ({ field, form }: CommonProps) => {
  const FieldComponent = typeMap[field.fieldType]?.component;

  if (!FieldComponent) {
    return null;
  }

  return <FieldComponent field={field} form={form} />;
};

export default BulkEditField;
